@if (relatedItems?.length > 0) {
  <table class="w-full mt-4">
    <thead class="text-left border-b border-gray-300/50">
      <th class="w-1/12">Náhled</th>
      <th class="w-3/12">ID</th>
      <th class="w-2/12 truncate">Autor</th>
      <th class="w-3/12 truncate">Název</th>
      <th class="w-2/12 truncate">Vztah</th>
      <!-- Actions column -->
      <!-- <th class="w-2/12"></th> -->
    </thead>
    <tbody>
      @for (ri of relatedItems; track ri; let last = $last) {
        <tr
          [ngClass]="{ 'border-b border-gray-300/80': !last }"
          >
          <td class="flex justify-start w-16 pr-0 min-w-8">
            <img
          [src]="
            pictureService.getMainPictureFullFilename(ri.item) | photoProxy
          "
              class="object-scale-down w-16 h-16 align-middle"
              alt="Náhled díla"
              loading="lazy"
              />
          </td>
          <td>
            <art-item-inventory-code [item]="ri.item"></art-item-inventory-code>
          </td>
          <td>
            @for (author of ri.item['authors']; track author) {
              <div>
                {{ author.nickname }}
              </div>
            }
          </td>
          <td>{{ ri.item["originalTitle"] }}</td>
          <td>
            <div class="flex items-center justify-start w-full">
              <div>{{ ri.relationType["titleCS"] }}</div>
              @if (ri.relationType['isPublic']) {
                <mat-icon
                  svgIcon="mat:language"
                  class="ml-2 text-gray-300"
                  matTooltip="Veřejné spojení"
                ></mat-icon>
              }
            </div>
          </td>
          <!-- <td>
          <div class="flex items-start justify-end w-full h-full">
            <button
              class="hover:text-blue-500"
              (click)="this.prepareRelatedItemQuickDialog(ri.item)"
              mat-icon-button
              type="button"
              matTooltip="Zobrazit kartu díla"
              >
              <mat-icon svgIcon="mat:info"></mat-icon>
            </button>
          </div>
        </td> -->
      </tr>
    }
  </tbody>
</table>
}
